import { EServiceId } from '../types/reducers/publishTerms';

export const SERVICE_NAMES: { [serviceId in EServiceId]: string } = {
  [EServiceId.top]: 'Топ',
  [EServiceId.premium]: 'Премиум',
  [EServiceId.paid]: 'Стандарт',
  [EServiceId.free]: 'Стандарт',
};
